import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";

export const PhoneSpan = styled.span`
  border-bottom: 1px solid ${colors.rabbitGrey};
  cursor: pointer;
`;

PhoneSpan.displayName = "PhoneSpan";
